<template>
    <header
        class="px-[30px] flex bg-background-1 items-center"
        :class="headerClasses"
    >
        <component
            :is="icon"
            id="basic-header-logo"
            class="max-sm:hidden"
            :class="{ 'cursor-pointer': hasLogoNavigation }"
            @click="hasLogoNavigation ? navigateTo('/') : undefined"
        ></component>
        <div
            v-if="slots.title"
            class="flex-1 sm:ml-[30px]"
        >
            <slot name="title"> </slot>
        </div>
        <ChatIconWrapper
            v-if="displayChatIcon"
            class="mx-[20px] w-[20px] h-[20px]"
            icon-size="20"
        />
        <slot />
    </header>
</template>

<script lang="ts" setup>
import ChatIconWrapper from '@atoms/ChatIcon/ChatIconWrapper.vue';

export type Size = 's' | 'm';

export type BasicHeaderProps = {
    isTextLogo?: boolean;
    hasLogoNavigation?: boolean;
    displayChatIcon?: boolean;
    rwd?: boolean;
    size?: Size;
};

const props = withDefaults(defineProps<BasicHeaderProps>(), {
    isTextLogo: true,
    hasLogoNavigation: true,
    displayChatIcon: false,
    rwd: false,
    size: 'm',
});

export interface BasicHeaderSlots {
    default(): unknown;
    title?(): unknown;
}

const slots = defineSlots<BasicHeaderSlots>();

const importer = (isTextLogo: boolean) => () =>
    import(
        isTextLogo
            ? `../../../assets/icons/cm-logo.svg`
            : `../../../assets/icons/cm-logo-small.svg`
    );

const icon = computed(() => {
    return defineAsyncComponent(importer(props.isTextLogo));
});

const headerClasses = computed(() => {
    return [
        props.size === 'm' ? 'py-[30px]' : 'py-[15px]',
        props.rwd ? 'max-sm:flex-col max-sm:px-[20px]' : 'items-center',
    ];
});
</script>
